import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import { mainDataHomeText } from "../styles";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import PersonIcon from "@mui/icons-material/Person";
import AspectRatioIcon from "@mui/icons-material/AspectRatio";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import BathtubIcon from "@mui/icons-material/Bathtub";
import { KingBed } from "@mui/icons-material";
import DonutLargeIcon from "@mui/icons-material/DonutLarge";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import FindInPageIcon from "@mui/icons-material/FindInPage";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import StackedLineChartIcon from "@mui/icons-material/StackedLineChart";
import PhoneIcon from "@mui/icons-material/Phone";
import DescriptionIcon from "@mui/icons-material/Description";

const NoMaxWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: "none",
  },
});

function CardInvestment({ sizeXS, sizeMD, sizeLG, sizeSM, dataCard }) {
  function dateToInput(fechaOriginal) {
    if (!!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(fechaOriginal)) {
      const dateObject = new Date(fechaOriginal);
      const año = dateObject.getUTCFullYear();
      const mes = (dateObject.getUTCMonth() + 1).toString().padStart(2, "0");
      const día = dateObject.getUTCDate().toString().padStart(2, "0");

      return `${año}-${mes}-${día}`;
    } else return fechaOriginal;
  }

  const formatVerified = (status) => {
    if (status === "approved") {
      return "Aprobado";
    } else if (status === "pending") {
      return "Pendiente";
    } else if (status === "rejected") {
      return "Rechazado";
    } else {
      return "Desconocido";
    }
  };

  return (
    <Grid item xs={sizeXS} sm={sizeSM} md={sizeMD} lg={sizeLG}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          borderRadius: 4,
          p: { xs: 1, md: 2 },
        }}
      >
        <Stack
          component="article"
          sx={{
            width: "100%", // Anchura fija
            height: { xs: 150, md: 150 },
            mb: 1.5,
          }}
        >
          <img
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              aspectRatio: "9/16",
              borderRadius: "8px",
            }}
            src={
              dataCard?.Project?.photo_profile[0]?.url ||
              "https://as1.ftcdn.net/v2/jpg/06/00/88/96/1000_F_600889685_N2bnfSBEyYDNW6tExn2riTS9McpnFWew.jpg"
            }
            alt="Property | Projects"
          />
        </Stack>
        <Stack
          spacing={{ xs: 0, md: 2 }}
          component="article"
          position="relative"
          sx={{ overflowX: "hidden" }}
          height="100%"
        >
          <NoMaxWidthTooltip
            disableHoverListener={dataCard?.Project?.name.length <= 20}
            title={dataCard?.Project?.name}
            arrow
          >
            <Typography
              component="h2"
              variant="h6"
              sx={{
                textTransform: "capitalize",
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                WebkitLineClamp: 1,
                mb: 1,
                fontWeight: 700,
                fontSize: "medium",
                fontFamily: "Inter",
              }}
            >
              {dataCard?.Project?.name.length > 20
                ? dataCard?.Project?.name.slice(0, 20) + "..."
                : dataCard?.Project?.name}
            </Typography>
          </NoMaxWidthTooltip>
          <Stack sx={{ mt: "8px !important" }}>
            <Typography
              component="span"
              sx={{
                fontWeight: 700,
                letterSpacing: ".5px",
                fontSize: "small",
                color:
                  dataCard?.status === "approved"
                    ? "#0c1a00"
                    : dataCard?.status === "pending"
                      ? "#544300"
                      : "#470000",
                display: "block",
                px: 2,
                width: "fit-content",
                borderRadius: 2,
                backgroundColor:
                  dataCard?.status === "approved"
                    ? "#a6ed82a8"
                    : dataCard?.status === "pending"
                      ? "#f4e24fa8"
                      : "#ee63638c",
              }}
            >
              {formatVerified(dataCard?.status)}
            </Typography>
          </Stack>
          <Stack>
            <Typography
              component="span"
              sx={{
                marginBottom: 0.5,
                fontSize: "small",
                fontWeight: "normal",
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                textOverflow: "ellipsis",
                WebkitLineClamp: 3, // Ajusta el número de líneas visibles aquí
              }}
            >
              {dataCard?.Project?.information}
            </Typography>
          </Stack>
          <Stack
            width={{ xs: "100%", md: "100%" }}
            marginInline="auto"
            flexDirection="row"
            justifyContent="start"
            gap={1}
            mb={4}
          >
            <NoMaxWidthTooltip title="Cantidad invertida" arrow>
              <Typography
                component="span"
                sx={{
                  ...mainDataHomeText,
                }}
              >
                <LocalAtmIcon />
                {parseInt(dataCard?.invested_value).toLocaleString("es-CO")}
              </Typography>
            </NoMaxWidthTooltip>
            <NoMaxWidthTooltip title="Teléfono" arrow>
              <Typography
                component="span"
                sx={{
                  ...mainDataHomeText,
                }}
              >
                <PhoneIcon />
                {dataCard?.phone}
              </Typography>
            </NoMaxWidthTooltip>
          </Stack>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 1,
              justifyContent: "start",
            }}
          >
            {/*     <Button */}
            {/*       size="small" */}
            {/*       sx={{ */}
            {/*         px: "0.5rem", */}
            {/*         width: "fit-content", */}
            {/*         color: "white", */}
            {/*         backgroundColor: "primary.main", */}
            {/*         borderRadius: 2, */}
            {/*         "&:hover": { */}
            {/*           backgroundColor: "primary.300", */}
            {/*         }, */}
            {/*       }} */}
            {/*       LinkComponent={Link} */}
            {/*       startIcon={<EditIcon fontSize="small" />} */}
            {/*       to={`/edit/investment/${dataCard.id}`} */}
            {/*     > */}
            {/*       Editar */}
            {/*     </Button> */}
            <Button
              size="small"
              sx={{
                px: "0.5rem",
                width: "fit-content",
                color: "white",
                backgroundColor: "primary.main",
                borderRadius: 2,
                "&:hover": {
                  backgroundColor: "primary.300",
                },
              }}
              LinkComponent={Link}
              startIcon={<StackedLineChartIcon fontSize="small" />}
              to={`/details/project/${dataCard?.Project?.id}`}
            >
              Ver proyecto
            </Button>
            {/*     <Button */}
            {/*       size="small" */}
            {/*       sx={{ */}
            {/*         px: "0.5rem", */}
            {/*         width: "fit-content", */}
            {/*         color: "white", */}
            {/*         backgroundColor: "#d32f2f", */}
            {/*         borderRadius: 2, */}
            {/*         "&:hover": { */}
            {/*           backgroundColor: "#da4e4e", */}
            {/*         }, */}
            {/*       }} */}
            {/*       startIcon={<DeleteIcon fontSize="small" />} */}
            {/*     > */}
            {/*       Eliminar */}
            {/*     </Button> */}
          </Box>
        </Stack>
      </Box>
    </Grid>
  );
}

export default CardInvestment;
